export default "__VITE_ASSET__a7e7a78e__"